import Vue from 'vue';
import exchangeRateCard from './exchange-rate-card/exchange-rate-card';
import store from '../common/js/vuex/store';
import exchangeRateAfirStore from '../applications/exchange-rate-card/exchange-rate-card-vuex';
if (!store.hasModule(['exchangeRateCard'])) {
	store.registerModule('exchangeRateCard', exchangeRateAfirStore);
}
Vue.component('exchange-rate-card', exchangeRateCard);
